<script lang="js" setup>
import { defineProps, computed } from 'vue'
import FileIcon from '@/assets/icons/file.svg'
import WebIcon from '@/assets/icons/web.svg'
import QaIcon from '@/assets/icons/qa.svg'
import TextIcon from '@/assets/icons/text.svg'
import { ShoppingBag } from 'lucide-vue-next'
import { replaceUrl } from '@/helpers'
import { useTranslations } from '@/translation'

const props = defineProps({
  message: {
    type: Object,
    required: true
  }
})
const getIcon = (context) => {
  switch (context) {
    case 'file':
      return FileIcon
    case 'web':
      return WebIcon
    case 'qa':
      return QaIcon
    case 'text':
      return TextIcon
    case 'product':
      return ShoppingBag
    default:
      return ShoppingBag
  }
}
const mapSources = computed(() => {
  return props.message.source.map((source) => {
    const newSource = source
    if (newSource.source_type === 'product') {
      newSource.url = replaceUrl(newSource?.attributes?.product_url) || ''
    } else {
      newSource.url = replaceUrl(newSource?.attributes?.url) || ''
    }
    return newSource
  })
})
const { t } = useTranslations()
const getTooltip = (context) => {
  return context && context !== null && context !== 'null'
    ? t(`source.type.${context}`)
    : t('source.type.default')
}
</script>

<template>
  <div
    class="flex flex-col gap-2 items-baseline border-b pb-2 last:border-0 border-appBorder"
    v-for="source in mapSources"
    :key="source.id"
  >
    <div class="flex gap-2 items-center">
      <div
        v-tooltip="getTooltip(source.document_context || source.source_type || 'default')"
        class="flex items-center"
        :aria-label="getTooltip(source.document_context || source.source_type || 'default')"
        role="img"
      >
        <component :is="getIcon(source.document_context)" />
      </div>
      <div class="text-sm" v-if="source?.title && source?.title !== 'null'">
        <h3 class="text-sm text-bold font-semibold text-primary">{{ t('source.title') }}</h3>
        <span>{{ source.title }}</span>
      </div>
    </div>

    <div class="text-sm" v-if="source?.url && source.url.length">
      <h4 class="text-sm text-bold font-semibold text-primary">{{ t('source.button.url') }}</h4>
      <a
        class="underline text-sm"
        :href="source.url"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="t('aria.openLinkInNewTab')"
        >{{ source.url }}</a
      >
    </div>
  </div>
</template>
